import React, { useEffect } from 'react'

const Header = () => {
  useEffect(() => {
    document.querySelector('.mobileMenu-toggle')
      .addEventListener('click', onMenuToggle)

    const anchors = document.querySelectorAll('.navPages-list a')

    for (const anchor of anchors) {
      anchor.addEventListener('click', onSubMenuToggle)
    }

    return () => {
      document.querySelector('.mobileMenu-toggle')
        .removeEventListener('click', onMenuToggle)

      const anchors = document.querySelectorAll('.navPages-list a')
      for (const anchor of anchors) {
        anchor.removeEventListener('click', onSubMenuToggle)
      }
    }
  })

  const onMenuToggle = e => {
    const target = document.querySelector('#menu')
    if (!target.classList.contains('is-open')) {
      target.classList.add('is-open')
      document.querySelector('.mobileMenu-toggle').classList.add('is-open')
    } else {
      target.classList.remove('is-open')
      document.querySelector('.mobileMenu-toggle').classList.remove('is-open')
    }

  }

  const onSubMenuToggle = e => {

    const target = e.target.parentNode.querySelector('.navPage-subMenu')
    if (target != null) {
      e.preventDefault()
      if (!target.classList.contains('is-open')) {
        target.classList.add('is-open')
      } else {
        target.classList.remove('is-open')
      }
    }

  }

  return (
    <div
      className="stellar"
      dangerouslySetInnerHTML={{__html: headerString}}
    >
    </div>
  )
}

export default Header

const headerString = `
<header class="header no-cat-header" role="banner">
    <div class="header__topbar">
        <div class="header__nav">
            <div class="navPages-container" id="menu" data-menu="" aria-hidden="true">
                <nav class="navPages no-cat-header__navPages">

    <ul class="navPages-list">
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/lab-consumables/" data-collapsible="navPages-18" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-18" aria-expanded="false">
    Lab Consumables <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-18" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-consumables/">All Lab Consumables</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/agarose/" data-collapsible="navPages-79" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-79">
                        Agarose <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-79" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/specialty-agarose/">Specialty Agarose</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/autoclave-and-bio-hazard-bags/">Autoclave and bio-hazard bags</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/autoradiography/">Autoradiography</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/bacterial-and-yeast-flasks/">Bacterial and Yeast Flasks</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/buffers-1/">Buffers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/centrifuge-tubes/" data-collapsible="navPages-105" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-105">
                        Centrifuge Tubes <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-105" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/15-and-50ml-tubes/">15 and 50mL Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/5ml-centrifuge-tubes/">5mL Centrifuge Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/centrisolo-conical-tubes/">CentriSolo™ Conical Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/itubes-colorful-conical-tubes/">iTubes™ Colorful Conical Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/seemore-tube-series/">SeeMore™ Tube Series</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/specialty-centrifuge-tubes/">Specialty Centrifuge Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/t3-tube-micro-centrifuge-tube/">T3 Tube™ Micro-Tube</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/the-deadbolt-tube/">The Deadbolt™ Tube</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/cryovials/" data-collapsible="navPages-98" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-98">
                        Cryovials <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-98" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/external-thread-cryovials/">External Thread Cryovials</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/internal-thread-cryovials/">Internal Thread Cryovials</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/cryovial-caps-and-inserts/">Cryovial Caps and Inserts</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/cuvettes/">Cuvettes</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/drosophila-vials/">Drosophila Vials</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/flow-cytometry/" data-collapsible="navPages-306" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-306">
                        Flow Cytometry  <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-306" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/facs-tubes/">FACS Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/swish-cell-strainers/">SWiSH™ Cell Strainers</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/gloves/" data-collapsible="navPages-55" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-55">
                        Gloves <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-55" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/chloroprene-gloves/">Chloroprene Gloves</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/latex-gloves/">Latex Gloves</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/nitrile-gloves/">Nitrile Gloves</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-notebooks/">Lab Notebooks</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/liquid-handling/" data-collapsible="navPages-41" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-41">
                        Liquid Handling <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-41" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/pipette-tips/">Pipette Tips</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/plastic-pasteur-pipets/">Plastic Pasteur Pipets</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/robotic-liquid-handling/">Robotic Liquid Handling</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/reagent-reservoirs/">Reagent Reservoirs</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/vistalab-macro-tips/">VistaLab Macro Tips</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/vistalab-micro-tips/">VistaLab Micro Tips</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/repeater-tips/">Repeater Tips</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/transfer-pipettes/">Transfer Pipettes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/wobble-not-pipettes/">Wobble-Not Pipettes</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/microscope-slides-and-cover-glass/" data-collapsible="navPages-48" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-48">
                        Microscope slides and cover glass <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-48" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/microscope-cover-glass/">Microscope Cover Glass</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/microscope-slide-accessories/">Microscope Slide Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/microscope-slides-1/">Microscope slides</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/multi-well-plates/" data-collapsible="navPages-52" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-52">
                        Multi-well Plates <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-52" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/cluster-tubes/">Cluster Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/deep-well-plates/">Deep Well Plates</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/elisa-plates/">ELISA plates</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/microtest-plates/">MicroTest Plates</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/parafilm/">Parafilm</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/pcr-supplies/" data-collapsible="navPages-102" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-102">
                        PCR Supplies <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-102" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/pcr-plate-seals/">PCR Plate Seals</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/pcr-plates-and-pcr-tubes/">PCR Plates and PCR Tubes</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/storage-solutions/" data-collapsible="navPages-19" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-19">
                        Storage Solutions <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-19" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/beakers-and-cylinders/">Beakers and Cylinders</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/carboys/">Carboys</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/storage-bottles/">Storage Bottles</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/freezer-boxes/">Freezer Boxes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/lab-glassware/">Lab Glassware</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/ice-buckets/">Ice Buckets</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/media-bottles/">Media Bottles</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/sample-bags/">Sample Bags</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/sharps-containers/">Sharps containers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/transport-tubes/">Transport Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/tube-chillers-and-coolers/">Tube Chillers and Coolers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/tube-racks/">Tube Racks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/vacuum-storage-bottles/">Vacuum Storage Bottles</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/wash-bottles/">Wash Bottles </a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/consumables/test-tubes/" data-collapsible="navPages-134" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-134">
                        Glass Test Tubes <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-134" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/caps-and-racks-for-test-tubes/">Caps and Racks for Test Tubes</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/tissue-culture-products/" data-collapsible="navPages-22" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-22">
                        Tissue Culture Products <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-22" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/3d-cell-culture/">3D Cell Culture</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/cell-culture-plate-inserts/">Cell Culture Plate Inserts</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/cell-scrapers/">Cell Scrapers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/chamber-slides/">Chamber Slides</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/culture-tubes/">Culture Tubes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/dishes-non-treated/">Dishes - Non Treated</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/dishes-treated/">Dishes - Treated</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/erlenmeyer-flasks/">Erlenmeyer Flasks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/filtration/">Filtration</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/flasks-non-treated/">Flasks - Non Treated</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/flasks-treated/">Flasks - Treated</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/nanopatterned-cultureware/">Nanopatterned Cultureware</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/nest-biofactory-systems/">Nest BioFactory™ Systems</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/plates-non-treated/">Plates - Non treated</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/plates-treated/">Plates - Treated</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/spreaders-and-needles/">Spreaders and Needles</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/tissue-culture-packages/">Tissue Culture Packages</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/urinalysis-products/">Urinalysis Products</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/weigh-boats-and-spatulas/">Weigh Boats And Spatulas</a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/large-lab-equipment/" data-collapsible="navPages-25" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-25" aria-expanded="false">
    Large Lab Equipment <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-25" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/large-lab-equipment/">All Large Lab Equipment</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/bactron-anaerobic-chambers/">Bactron Anaerobic Chambers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/climate-chambers/">Climate Chambers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/hermle-centrifuges/" data-collapsible="navPages-96" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-96">
                        Hermle Centrifuges <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-96" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/filtration-centrifuge/">Filtration Centrifuge</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-centrifuge-bundles/">Hermle Centrifuge Bundles</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/oil-testing-centrifuge/">Oil Testing Centrifuge</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/universal-centrifuges/">Universal Centrifuges</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-freezers/">Lab Freezers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/lab-incubators/" data-collapsible="navPages-54" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-54">
                        Lab Incubators <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-54" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/co2-incubators-1/">CO2 Incubators</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/drosophila-incubators/">Drosophila Incubators</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/general-use-incubators/">General Use Incubators</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/refrigerated-incubators/">Refrigerated Incubators</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/shaking-incubators/">Shaking Incubators</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/laboratory-chairs/">Laboratory Chairs</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/large-orbital-shakers/">Large Orbital Shakers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-ovens/">Lab Ovens</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lyophilizers/">Lyophilizers</a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/benchtop-lab-equipment/" data-collapsible="navPages-21" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-21" aria-expanded="false">
    Benchtop Lab Equipment <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-21" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/benchtop-lab-equipment/">All Benchtop Lab Equipment</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/autoclaves/" data-collapsible="navPages-29" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-29">
                        Autoclaves <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-29" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/sterilizers/">Sterilizers</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/cell-stretcher/">Cell Stretcher</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/balances-and-scales/" data-collapsible="navPages-74" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-74">
                        Balances and Scales <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-74" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/analytical-balances/">Analytical Balances</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/compact-balances/">Compact Balances</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/moisture-analayzers/">Moisture Analayzers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/precision-balances/">Precision Balances</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/centrifuges/" data-collapsible="navPages-116" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-116">
                        Centrifuges <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-116" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/clinical-centrifuges/">Clinical Centrifuges</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/micro-centrifuges/">Micro-centrifuges</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/mini-centrifuges/">Mini-Centrifuges</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/microplate-spinners/">Microplate Spinners</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/dry-baths/">Dry Baths</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/homogenizers/">Homogenizers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/hotplates-stirrers/" data-collapsible="navPages-91" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-91">
                        Hotplates/Stirrers <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-91" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/stir-bars/">Stir Bars</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/incubators/" data-collapsible="navPages-49" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-49">
                        Incubators <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-49" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/co2-incubators/">CO2 Incubators</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/general-use-incubators-1/">General Use Incubators</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/shaking-incubators-1/">Shaking Incubators</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/microplate-readers/">Microplate Readers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/microplate-sealers/">Microplate Sealers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/orbital-shakers/">Orbital Shakers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/lab-organization-and-storage/" data-collapsible="navPages-147" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-147">
                        Lab Organization and Storage <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-147" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/benchtop-storage/">Benchtop Storage</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/glove-and-wipe-boxes/">Glove and Wipe Boxes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/lab-timers/">Lab Timers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/laboratory-labeler-and-tape/">Laboratory Labeler And Tape</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/specimen-transport/">Specimen Transport</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/ph-meters/" data-collapsible="navPages-73" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-73">
                        pH Meters <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-73" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/buffers/">Buffers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/electrodes-and-probes/">Electrodes and Probes</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/pipettes/" data-collapsible="navPages-33" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-33">
                        Pipettes <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-33" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/bottle-top-dispensers/">Bottle Top Dispensers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/electronic-pipettes/">Electronic Pipettes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/pipette-checkit-tool/">Pipette Checkit® Tool</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/ergonomic-pipettes/">Ergonomic Pipettes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/multi-channel-pipettes/">Multi-Channel Pipettes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/pipette-stands-and-carousels/">Pipette Stands and Carousels</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/pipette-controllers/">Pipette Controllers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/manual-pipettes/">Manual Pipettes</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/pumps-vacuums/">Pumps/Vacuums</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/rockers-and-rollers/">Rockers and Rollers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/thermal-cyclers/" data-collapsible="navPages-87" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-87">
                        Thermal Cyclers <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-87" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/real-time-thermal-cyclers/">Real-Time Thermal Cyclers</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/vortex-mixers/">Vortex Mixers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/water-baths/" data-collapsible="navPages-68" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-68">
                        Water Baths <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-68" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/digital-water-baths/">Digital Water Baths</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/rings-floats-for-water-baths/">Rings/Floats for Water Baths</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/shaking-water-baths/">Shaking Water Baths</a>
                        </li>
                    </ul>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/electrophoresis/" data-collapsible="navPages-26" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-26" aria-expanded="false">
    Electrophoresis <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-26" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/electrophoresis/">All Electrophoresis</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/agarose-for-dna-gels/">Agarose for DNA Gels</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/automated-blot-processor/">Automated Blot Processor</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/blot-boxes/">Blot Boxes</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/electrophoresis-buffers/">Electrophoresis Buffers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/dyes-and-stains-for-visualization/">Dyes and Stains for Visualization</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/ecl-substrate-kits/">ECL Substrate Kits</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/gel-documentation/">Gel Documentation</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/horizontal-gel-units/" data-collapsible="navPages-93" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-93">
                        Horizontal Gel Units <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-93" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/enduro-gel-boxes/">ENDURO Gel Boxes</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/page-electroblotting-2d-gels/">PAGE/electroblotting/2D gels</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/pre-cast-gels/">Pre-Cast Gels</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/power-supply/">Power Supply</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/semi-dry-blot/">Semi-Dry Blot</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/transilluminators/">Transilluminators</a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/molecular-biology/" data-collapsible="navPages-158" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-158" aria-expanded="false">
    Molecular Biology <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-158" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/molecular-biology/">All Molecular Biology</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/cloning/">Cloning</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/dna-markers-ladders/">DNA Markers/Ladders</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/magnetic-bead-consumables/">Magnetic Bead Consumables</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/microgem-nucleic-acid-prep/" data-collapsible="navPages-372" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-372">
                        MicroGEM Nucleic Acid Prep <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-372" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/bacterial-sample-prep/">Bacterial Sample Prep</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/forensic-lab-tissue-prep/">Forensic Lab Tissue Prep</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/life-science-tissue-prep/">Life Science Tissue Prep </a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/plant-tissue-sample/">Plant Tissue Sample</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/rna-sample-prep/">RNA Sample Prep</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/sperm-cell-prep/">Sperm Cell Prep</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/transfection-kits-and-reagents/">Transfection Kits and Reagents</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/virus-purification/">Virus Purification</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/protein-ladders-and-stains/">Protein Ladders and Stains</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/dna-prep-kits/" data-collapsible="navPages-198" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-198">
                        DNA Prep Kits <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-198" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/fragment-dna-purification/">Fragment DNA Purification</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/genomic-dna-purification/">Genomic DNA Purification</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/plasmid-dna-purification/">Plasmid DNA Purification </a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/rna-extraction-kits/">RNA Extraction Kits</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/pcr-enzymes-and-kits/" data-collapsible="navPages-197" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-197">
                        PCR Enzymes and Kits <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-197" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/accuris-pcr-reagents/">Accuris™ PCR Reagents</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/dntps-for-pcr/">dNTPs for PCR</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/radiant-pcr-reagents/">Radiant™ PCR Reagents</a>
                        </li>
                    </ul>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/lab-freezer-racks/" data-collapsible="navPages-80" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-80" aria-expanded="false">
    Lab Freezer Racks <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-80" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-freezer-racks/">All Lab Freezer Racks</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/upright-freezer-racks/" data-collapsible="navPages-161" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-161">
                        Upright Freezer Racks <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-161" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/2-inch-box-freezer-racks/">2 Inch Box Freezer Racks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/3-inch-box-freezer-racks/">3 Inch Box Freezer Racks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/15-and-50ml-conical-tube-racks/">15 and 50mL Conical Tube Racks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/blood-sample-tube-racks/">Blood Sample Tube Racks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/fifty-place-boxes-with-hinged-lid/">Fifty-Place Boxes with Hinged Lid</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/96-and-384-well-plate-freezer-racks/">96 and 384 Well Plate Freezer Racks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/microscope-slide-box-freezer-racks/">Microscope Slide Box Freezer Racks</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/storage-bottle-freezer-racks/">Storage Bottle Freezer Racks</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/chest-freezer-racks/" data-collapsible="navPages-162" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-162">
                        Chest Freezer Racks <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-162" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/2-inch-boxes-1/">2 inch boxes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/3-inch-boxes-1/">3 inch boxes</a>
                        </li>
                    </ul>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/product-accessories/" data-collapsible="navPages-122" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-122" aria-expanded="false">
    Product Accessories <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-122" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/product-accessories/">All Product Accessories</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/balance-weigh-sets-and-tools/">Balance Weigh Sets and Tools</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/dry-bath-blocks/" data-collapsible="navPages-124" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-124">
                        Dry Bath Blocks <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-124" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-benchmark-products/">For Benchmark Products</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-labnet-dry-baths/">For Labnet Dry Baths</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-vitl-products/">For Vitl Products</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/lab-armor-beads/">Lab Armor Beads</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/shel-lab-bactron-accessories/">Shel Lab Bactron Accessories</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/centrifuge-rotors/" data-collapsible="navPages-126" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-126">
                        Centrifuge Rotors <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-126" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z206a/">For Hermle Z206A</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z207-m/">For Hermle Z207-M</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z216m/">For Hermle Z216M</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z287-a/">For Hermle Z287-A</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z306/">For Hermle Z306 </a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z326-and-z326k/">For Hermle Z326 and Z326K</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z366-and-z366k/">For Hermle Z366 and Z366K </a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z32hk/">For Hermle Z32HK</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z36hk/">For Hermle Z36HK</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z446-and-z446k/">For Hermle Z446 and Z446K</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-hermle-z496/">For Hermle Z496</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/centrifuge-buckets-and-inserts/" data-collapsible="navPages-366" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-366">
                        Centrifuge Buckets and Inserts <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-366" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z206-accessories/">Hermle Z206 Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z306-accessories/">Hermle Z306 Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z326-accessories/">Hermle Z326 Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z366-accessories/">Hermle Z366 Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z32hk-accessories/">Hermle Z32HK Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z36hk-accessories/">Hermle Z36HK Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z446-accessories/">Hermle Z446 Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/hermle-z496k-accessories/">Hermle Z496K Accessories</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/clamps-racks-for-shakers-incubators/" data-collapsible="navPages-125" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-125">
                        Clamps/racks for shakers/incubators <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-125" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/benchmark-clamps/">Benchmark Clamps</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/labnet-clamps/">Labnet Clamps</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/filters-for-microplate-readers/">Filters for Microplate Readers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/gel-box-accessories/" data-collapsible="navPages-127" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-127">
                        Gel Box Accessories <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-127" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-accuris-gel-boxes/">For Accuris Gel Boxes</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/for-labnet-gel-boxes/">For Labnet Gel Boxes</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/homogenizer-beads/" data-collapsible="navPages-138" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-138">
                        Homogenizer beads <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-138" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/beads-for-benchmark-homogenizers/">Beads for Benchmark Homogenizers</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/beads-for-next-advance-homogenizers/">Beads for Next Advance Homogenizers</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/labeler-lab-printer-label-tapes/">LABeler™ Lab Printer label tapes</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/plate-heat-seals/">Plate Heat Seals</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/platforms-for-rockers-shakers/" data-collapsible="navPages-123" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-123">
                        Platforms for rockers/shakers <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-123" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/benchwaver-platforms/">Benchwaver Platforms</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/labnet-labroller/">Labnet LabRoller™</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/roto-mini-tube-accessories/">Roto-Mini™ Tube Accessories</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/rotobot-tube-accessories/">RotoBot™ Tube Accessories</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/racks-for-water-baths/">Racks for water baths</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/ring-weights-for-water-baths/">Ring Weights for Water Baths</a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/microscopy/" data-collapsible="navPages-78" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-78" aria-expanded="false">
    Microscopy <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-78" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/microscopy/">All Microscopy</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/compound-microscopes/" data-collapsible="navPages-135" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-135">
                        Compound Microscopes <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-135" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-panthera-series/">Motic Panthera Series</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-ba210-series/">Motic BA210 Series</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-ba310-series/">Motic BA310 Series</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-410e-series/">Motic 410E Series</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/inverted-microscopes/" data-collapsible="navPages-136" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-136">
                        Inverted Microscopes <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-136" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-ae2000/">Motic AE2000</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-ae31/">Motic AE31</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/stereo-dissecting-microscopes/" data-collapsible="navPages-142" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-142">
                        Stereo (dissecting) Microscopes  <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-142" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-smz-140-line-of-stereo-microscopes/">Motic SMZ-140</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-smz-161/">Motic SMZ-161</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-smz-168/">Motic SMZ-168</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-smz-171/">Motic SMZ-171</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/microscope-accessories-1/" data-collapsible="navPages-137" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-137">
                        Microscope accessories <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-137" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/fluorescence-kits/">Fluorescence Kits</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/sliders-and-condensers/">Sliders and Condensers</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/digital-imaging/" data-collapsible="navPages-159" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-159">
                        Digital Imaging <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-159" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/motic-ccd-cameras/">Motic CCD Cameras</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/cmos-cameras/">Motic CMOS Cameras</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/moticam-multi-output/">Moticam Multi-Output</a>
                        </li>
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/moticam-tablets/">Moticam Tablets</a>
                        </li>
                    </ul>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/lab-chemicals/" data-collapsible="navPages-272" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-272" aria-expanded="false">
    Lab Chemicals <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-272" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-chemicals/">All Lab Chemicals</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/acids-and-bases/">Acids and Bases</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/analytical-and-chromotography/">Analytical and Chromotography</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/chemical-buffers/">Chemical Buffers</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/salts/">Salts</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/solvents/">Solvents</a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/analytical-chemistry/" data-collapsible="navPages-249" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-249" aria-expanded="false">
    Analytical Chemistry <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-249" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/analytical-chemistry/">All Analytical Chemistry</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/autosampler-vials-and-caps/">Autosampler vials and caps</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/solvent-filtration/">Solvent Filtration</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/syringe-filters-1/">Syringe Filters </a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/lab-safety/" data-collapsible="navPages-298" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-298" aria-expanded="false">
    Lab Safety <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-298" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-safety/">All Lab Safety</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/lab-vacuum-systems/" data-collapsible="navPages-302" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-302">
                        Lab Vacuum Systems <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-302" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/vactrap-vacuum-trap-system/">Vactrap™ - Vacuum Trap System</a>
                        </li>
                    </ul>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/safety-storage/">Safety Storage</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action has-subMenu is-open" href="https://www.stellarscientific.com/gloves-1/" data-collapsible="navPages-299" data-collapsible-disabled-breakpoint="medium" data-collapsible-disabled-state="open" data-collapsible-enabled-state="closed" aria-expanded="true" aria-controls="navPages-299">
                        Gloves <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
                    </a>
                    <ul class="navPage-childList is-open" id="navPages-299" aria-hidden="false">
                        <li class="navPage-childList-item">
                            <a class="navPage-childList-action navPages-action" href="https://www.stellarscientific.com/nitrile-gloves-1/">Nitrile Gloves</a>
                        </li>
                    </ul>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/special-deals/" data-collapsible="navPages-82" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-82" aria-expanded="false">
    Special Deals <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-82" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/special-deals/">All Special Deals</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/benchmark-and-accuris-specials/">Benchmark and Accuris Specials</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/black-friday-deals/">Black Friday Deals</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/deals-from-foxx-lifesciences/">Deals From Foxx LifeSciences</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/labnet-lab-values-specials/">Labnet Lab Values Specials</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/labnet-liquid-handling/">Labnet Liquid Handling</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/monthly-lab-specials/">Monthly Lab Specials</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/promotions/">Promotions</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/welcome-back/">Welcome Back!</a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action" href="https://www.stellarscientific.com/stellar-swag/">Stellar Swag</a>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action has-subMenu navPages-action--toplevel" href="https://www.stellarscientific.com/covid-19-coronavirus/" data-collapsible="navPages-406" data-collapsible-disabled-breakpoint="medium" aria-controls="navPages-406" aria-expanded="false">
    COVID-19 Coronavirus <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg><use xlink:href="#icon-chevron-down"></use></svg></i>
</a>
<div class="navPage-subMenu" id="navPages-406" aria-hidden="true" tabindex="-1">
    <ul class="navPage-subMenu-list">
        <li class="navPage-subMenu-item">
            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/covid-19-coronavirus/">All COVID-19 Coronavirus</a>
        </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/covid-19-molecular-products/">COVID-19 Molecular Products</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/covid-19-swabs-and-vtm/">COVID-19 Swabs and VTM</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/lab-equipment-for-covid-19-test-prep/">Lab Equipment for COVID-19 Test Prep</a>
            </li>
            <li class="navPage-subMenu-item">
                    <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/ppe-for-covid-19/">PPE For COVID-19</a>
            </li>

    </ul>
</div>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action" href="https://www.stellarscientific.com/catalogs/">Catalogs</a>
        </li>
        <li class="navPages-item no-cat-header__category">
            <a class="navPages-action" href="https://www.stellarscientific.com/pending/">pending</a>
        </li>
        <li class="navPages-item navPages-item-label">
            <p class="navPages-action">BRANDS</p>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-x" class="navPages-action">BENCHMARK</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xx" class="navPages-action">LABNET</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxx" class="navPages-action">ARGOS TECHNOLOGIES</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxxx" class="navPages-action">CELTREAT</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxxxxx" class="navPages-action">HEATHROW SCIENTIFIC</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xx" class="navPages-action">FOX LIFE SCIENCES</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxx" class="navPages-action">MOTIC MICROSCOPY</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxxx" class="navPages-action">CHEMPIRE CHEMICALS</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxxxxx" class="navPages-action">NEXT ADVANCE</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxxxxx" class="navPages-action">SHEL LAB</a>
        </li>
        <li class="navPages-item no-cat-header__brands">
            <a href="/brand-xxxxxx" class="navPages-action">VIEW ALL BRANDS</a>
        </li>
        <li class="navPages-item navPages-item-label">
                <p class="navPages-action">ADDITIONAL INFORMATION</p>
            </li>
                <li class="navPages-item navPages-item-page about-us" id="about-us-nav">
                    <a class="navPages-action" href="https://www.stellarscientific.com/about-us/">About Us</a>
                    <div class="about-us-nav-content" id="about-us-nav-content" style="display: none;">
                        <ul class="about-us__dropdown">
                            <li><a href="/testimonials/" class="about-us__link about-us__testimonials">Testimonials</a></li>
                            <li><a href="/certifications-and-affiliations/" class="about-us__link about-us__certs">Certifications and Affiliations</a></li>
                            <li><a href="/careers/" class="about-us__link about-us__careers">Careers</a></li>
                            <li><a href="/brand-ambassadors/" class="about-us__link about-us__brandam">Brand Ambassadors</a></li>
                            <li><a href="/our-partners/" class="about-us__link about-us__ourPartners">Our Partners</a></li>
                        </ul>
                    </div>
                </li>
                <li class="navPages-item navPages-item-page">
                    <a class="navPages-action" href="https://www.stellarscientific.com/faqs/">FAQs</a>
                </li>
                <li class="navPages-item navPages-item-page">
                    <a class="navPages-action" href="https://www.stellarscientific.com/contact-us/">Contact Us</a>
                </li>
                <li class="navPages-item navPages-item-page">
                    <a class="navPages-action" href="https://www.stellarscientific.com/loyalty-rewards/">Loyalty Rewards</a>
                </li>
                <li class="navPages-item navPages-item-page">
                    <a class="navPages-action" href="https://www.stellarscientific.com/privacy-policy/">Privacy Policy</a>
                </li>
                <li class="navPages-item navPages-item-page">
                    <a class="navPages-action" href="https://www.stellarscientific.com/ordering-shipping-returns/">Ordering/Shipping/Returns</a>
                </li>
                <li class="navPages-item navPages-item-page">
                    <a class="navPages-action" href="https://www.stellarscientific.com/blog/">News and Updates</a>
                </li>

        <li class="navPages-item">
            <a class="navPages-action" href="/giftcertificates.php">Gift Certificates</a>
        </li>

    </ul>
    <ul class="navPages-list navPages-list--user no-cat-header__navPages-list--user">
        <li class="navPages-item currency-mobile">
            <a class="navPages-action has-subMenu" href="#" data-collapsible="navPages-currency" aria-controls="navPages-currency" aria-expanded="false">
                        <img src="https://cdn11.bigcommerce.com/s-w9bdixgj/lib/flags/us.gif" border="0" alt="" role="presentation">
                        US Dollar
                <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg>
                        <use xmlns:xlink="https://www.w3.org/1999/xlink" xlink:href="#icon-chevron-down"></use>
                    </svg></i>
            </a>
            <div class="navPage-subMenu" id="navPages-currency" aria-hidden="true" tabindex="-1">
                <ul class="navPage-subMenu-list">
                    <li class="navPage-subMenu-item">
                        <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/?setCurrencyId=2">
                            Canadian Dollar
                        </a>
                    </li>
                    <li class="navPage-subMenu-item">
                        <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/?setCurrencyId=1">
                            <strong>US Dollar</strong>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
        <li class="navPages-Item">
        </li>
            <li class="navUser-item navUser-item--reorder">

                    <a class="navUser-action qrb__trigger header__reorder--link" href="##" data-reveal-id="popupLoginWindow">Reorder</a>
            </li>
            <li class="navPages-item navPages-item-label">
                <p class="navPages-action">ACCOUNT</p>
            </li>
            <li class="navPages-item desktop-none">
                <a class="navPages-action" href="/login.php">Sign in</a>
                <a class="navPages-action" href="/login.php?action=create_account">Register</a>
            </li>
    </ul>
    <div class="no-cat-header__phone--mobile desktop-none">
            <p class="no-cat-header__phone-text--top">For Questions or to Place an Order</p>
            <p class="no-cat-header__phone-text--bottom"><span>410-764-2225</span> | <span>844-300-7857</span></p>
        </div>

</nav>
            </div>
        </div>
    </div>

    <div class="header__topbar desktop-none">
        <ul class="navPages-list navPages-list--user no-cat-header__navPages-list--user">
            <li class="navPages-item">
                <a class="navPages-action has-subMenu" href="#" data-collapsible="navPages-currency--mobile" aria-controls="navPages-currency--mobile" aria-expanded="false">
                            <img src="https://cdn11.bigcommerce.com/s-w9bdixgj/lib/flags/us.gif" border="0" alt="" role="presentation">
                            <span class="mobilecurrency">US Dollar</span>
                    <i class="icon navPages-action-moreIcon" aria-hidden="true"><svg>
                            <use xmlns:xlink="https://www.w3.org/1999/xlink" xlink:href="#icon-chevron-down"></use>
                        </svg></i>
                </a>
                <div class="navPage-subMenu" id="navPages-currency--mobile" aria-hidden="true" tabindex="-1">
                    <ul class="navPage-subMenu-list">
                        <li class="navPage-subMenu-item">
                            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/?setCurrencyId=2">
                                Canadian Dollar
                            </a>
                        </li>
                        <li class="navPage-subMenu-item">
                            <a class="navPage-subMenu-action navPages-action" href="https://www.stellarscientific.com/?setCurrencyId=1">
                                <strong>US Dollar</strong>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="navPages-item">
                    <div class="navPages-Item" id="google_translate_element--mobile"><div>
                    </div></div></li>
            <li class="navPages-item">


                    <a class="navUser-action qrb__trigger header__reorder--link" href="##" data-reveal-id="popupLoginWindow">Reorder</a>
            </li>
        </ul>
    </div>

    <div class="header__main">

        <a href="#" class="mobileMenu-toggle" data-mobile-menu-toggle="menu" aria-controls="menu" aria-expanded="false">
            <span class="mobileMenu-toggleIcon">Toggle menu</span>
        </a>
        <div class="header__main-logo">
            <div class="header-logo header-logo--center">
                <a href="https://www.stellarscientific.com/">
            <div class="header-logo-image-container">
                <img class="header-logo-image" src="https://cdn11.bigcommerce.com/s-w9bdixgj/images/stencil/250x100/stellarscientific_logo_1577381209__76485.original.png" alt="Stellar Scientific" title="Stellar Scientific">
            </div>
</a>
            </div>
        </div>
        <div class="header__main-search">
            <div id="quickSearch" class="quickSearch" data-prevent-quick-search-close="" aria-hidden="true">
    <form class="form" action="https://stellarscientific.com/search.php">
        <fieldset class="form-fieldset">
            <div class="form-field">
                <label id="quick_search_label" class="is-srOnly" for="search_query">Search</label>
                <input class="form-input" data-search-quick="" name="search_query" id="search_query" data-error-message="Search field cannot be empty." placeholder="Search for Everything!" autocomplete="off" aria-labelledby="quick_search_label" aria-label="Search">
                <button type="submit" href="#" class="quickSearch--button button button--primary" aria-label="Search" title="Search">
                    <span class="icon icon--search" title="Toggle Mobile Search">
                        <svg><use xlink:href="#icon-search"></use></svg>
                    </span>
                </button>
            </div>
        </fieldset>
    </form>
    <section class="quickSearchResults" data-bind="html: results"></section>
</div>

            <div class="no-cat-header__phone">
                <p class="no-cat-header__phone-text--top">For Questions or to Place an Order</p>
                <a href="tel:1-410-764-2225" class="no-cat-header__phone-text--bottom"><span>410-764-2225</span></a>
                    <span class="no-cat-header__split"> | </span>
                    <a href="tel:1-844-300-7857" class="no-cat-header__phone-text--bottom"><span> 844-300-7857</span></a>
            </div>
        </div>
        <div class="header__main-actions">
            <a href="#" class=" mobileSearch-toggle button button--primary" id="toggle-mobileSearch" aria-label="Toggle Mobile Search" title="Toggle Mobile Search">
                <span class="icon icon--search" title="Toggle Mobile Search">
                    <svg>
                        <use xlink:href="#icon-search"></use>
                    </svg>
                </span>


            </a><ul class="navPages-list"><a href="#" class=" mobileSearch-toggle button button--primary" id="toggle-mobileSearch" aria-label="Toggle Mobile Search" title="Toggle Mobile Search">
                </a><li class="navPages-item"><a href="#" class=" mobileSearch-toggle button button--primary" id="toggle-mobileSearch" aria-label="Toggle Mobile Search" title="Toggle Mobile Search">
                    </a><a class="navPages-action has-subMenu navPages__account" href="##" data-reveal-id="popupLoginWindow">
                        <span class="icon icon--signin">
                                <svg><use xlink:href="#icon-signin"></use></svg>
                            </span>

                        <span class="mobile-none">SIGN IN</span>
                    </a>
                    <div class="navPage-subMenu no-cat-header__account-dropdown" id="navPages-account" aria-hidden="true" tabindex="-1">
                        <ul class="navPage-subMenu-list">
                            <li class="navPage-subMenu-item">
                                <a class="navPages-action" href="/login.php">Sign in</a>
                            </li>
                            <li class="navPage-subMenu-item">
                                <a class="navPages-action" href="/login.php?action=create_account">Register</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
            <a class="button button--primary no-cat-header__cart-btn" data-dropdown="cart-preview-dropdown" data-options="align:right" href="/cart.php" data-cart-preview="" aria-expanded="false">

                <span class="icon icon--cart">
                    <svg><use xlink:href="#icon-cart"></use></svg>
                </span>





                <span class="navUser-item-cartLabel">Cart</span> <span class="countPill cart-quantity" data-its-anim="number">0</span>
            </a>
            <div class="dropdown-menu" id="cart-preview-dropdown" data-dropdown-content="" aria-hidden="true"></div>
        </div>
    </div>

    <div data-content-region="header_bottom"></div>
</header>
`
